import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";

const CTA = () => {
  return (
    <section className="relative py-24 overflow-hidden bg-[#F9FAFB]">

      {/* Elementos decorativos de ingeniería (Sutiles) */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#F26B1D]/5 rounded-full blur-[100px] -z-10" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-500/5 rounded-full blur-[120px] -z-10" />

      {/* Patrón de puntos (Blueprint Style) */}
      <div
        className="absolute inset-0 opacity-[0.4]"
        style={{
          backgroundImage: "radial-gradient(#e5e7eb 1px, transparent 1px)",
          backgroundSize: "30px 30px"
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6">
        <div className="bg-white border border-gray-100 rounded-[3rem] p-8 md:p-16 shadow-2xl shadow-gray-200/50 text-center relative overflow-hidden">

          {/* Línea naranja decorativa en el borde superior */}
          <div className="absolute top-0 left-0 w-full h-2 bg-[#F26B1D]" />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight tracking-tight">
              ¿Listo para darle valor legal <br />
              <span className="text-[#F26B1D]">a tu propiedad?</span>
            </h2>

            <p className="mt-6 text-gray-600 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed font-medium">
              Obtén soluciones técnicas claras y seguras. No dejes tu patrimonio en el aire,
              formaliza hoy con expertos colegiados.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Link
              to="/contacto"
              className="w-full sm:w-auto px-10 py-4 bg-[#F26B1D] text-white font-bold rounded-2xl shadow-lg shadow-[#F26B1D]/30 hover:scale-105 hover:bg-[#d95c14] transition-all active:scale-95 flex items-center justify-center gap-3"
            >
              Solicitar asesoría gratuita
              <FaArrowRight />
            </Link>

            {/*<a
              href="https://wa.me/tu-numero"
              className="w-full sm:w-auto px-10 py-4 border-2 border-gray-100 text-gray-700 font-bold rounded-2xl hover:border-[#F26B1D] hover:text-[#F26B1D] transition-all text-center"
            >
              WhatsApp Directo
            </a>*/}
          </motion.div>

          {/* Beneficios rápidos */}
          <div className="mt-12 pt-8 border-t border-gray-50 flex flex-wrap justify-center gap-8">
            {[
              "Profesionales CIP",
              "Planos Visados",
              "Atención Online",
              "Saneamiento Legal"
            ].map((text, i) => (
              <div key={i} className="flex items-center gap-2 text-sm font-bold text-gray-400">
                <FaCheckCircle className="text-[#F26B1D]/40" />
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;